// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  memberId: __t.string(),
  state: __t.string(),
  ticketId: __t.option(__t.u64()),
  x: __t.f32(),
  z: __t.f32(),
  floor: __t.u32(),
  targetX: __t.f32(),
  targetZ: __t.f32(),
  targetFloor: __t.u32(),
  assignedStoveUid: __t.string(),
  lastStoveUid: __t.string(),
  washTargetUid: __t.string(),
  washDirtyId: __t.i64(),
  washPhase: __t.string(),
  takeOrderGuestId: __t.option(__t.u64()),
};
